import React from 'react';

// Material UI Components
import {Tooltip, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions } from '@material-ui/core';

// Icons
import FormatClearRoundedIcon from '@material-ui/icons/FormatClearRounded';
import InsertLinkRoundedIcon from '@material-ui/icons/InsertLinkRounded';

export default function TopRightButtons( {StyleButton, contentBlock, anchorKey, currentSelectionOffset, onClickRemoveLastFormat, onClickToggleLink} ) {
    const types = ["REMOVE LAST STYLE", "LINK"];
    const [open, setOpen] = React.useState(false);
    const [url, setURL] = React.useState('');

    let [linkActive, setLinkActive] = React.useState(false);

    const entities = contentBlock.getEntityAt(currentSelectionOffset);

    React.useEffect(() => {
        if(entities !== null){
            setLinkActive(true);
        }else if(entities === null){
            setLinkActive(false);
        }
    }, [entities, setLinkActive])

    // This method will open the dialog
    const handleClickOpen = () => {
        setOpen(true);
    };

    // This method will close the dialog
    const handleClose = () => {
        setOpen(false);
    };

    // This method will either toggle an link to the url given if there is no link already else it will turn off the active link
    const handleLink = () => {
        handleClose();
        if(linkActive === true){
            setLinkActive(false)
            onClickToggleLink("OFF", url);
        }else{
            onClickToggleLink("ON", url);
        }
    }

    /*
        This method will handle the keypress. If enter then it will execute the handleURL method 
        else if the escape key is pressed it will execute the handleClose method
    */
    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            onClickToggleLink("ON", url);
            handleClose()
        } else if(event.key === 'Escape'){
            handleClose()
        }
    }

    return (
        <React.Fragment>
            {
                types.map((item, index) => {
                    let currentFormat = (item === "LINK") ? linkActive : false;

                    return(
                        <div key={index} onMouseDown={(event) => {
                            event.preventDefault();

                            if(item === "REMOVE LAST STYLE"){
                                onClickRemoveLastFormat(anchorKey);
                            }else{
                                if(linkActive === true){
                                    handleLink();
                                }else{
                                    handleClickOpen();
                                }
                            }
                        }}>
                            <Tooltip title={item} placement="bottom">
                                <Button 
                                    aria-label={item} 
                                    className={StyleButton} 
                                    color={(currentFormat === true) ? "primary" : "inherit"} 
                                    size="large" 
                                    variant={(currentFormat === true) ? "contained" : "text"}>
                                    {
                                        item === "REMOVE LAST STYLE" ? <FormatClearRoundedIcon />
                                            : item === "LINK" ? <InsertLinkRoundedIcon />
                                                : ""
                                    }
                                </Button  >
                            </Tooltip>
                        </div>
                    );
                })
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alertTitle"
            >
                <DialogTitle id="alertTitle">Enter URL</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="url"
                        label="URL"
                        placeholder="www.google.com"
                        type="text"
                        onChange={(event) => setURL(event.target.value)}
                        onKeyPress={(event) => handleKeyPress(event)}
                        variant="outlined"
                        required
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button disabled={url === "" ? true : false} onClick={handleLink} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}